// eslint-disable-next-line import/prefer-default-export
export const titleCase = (param: string): string => param.replace(
  /^_*(.)|_+(.)/g,
  (_s, c, d) => (c ? (c as string).toUpperCase() : ` ${(d as string).toUpperCase()}`),
);

